import { render } from "./ProviderManage.vue?vue&type=template&id=60924e82"
import script from "./ProviderManage.vue?vue&type=script&lang=js"
export * from "./ProviderManage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__